export enum DirectorRemunerationStatus {
  todo = 'to_do',
  toCheck = 'to_check',
  readyToBeSent = 'ready_to_be_sent',
  sent = 'sent',
  done = 'done',
  ignored = 'ignored'
}
